import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page Not Found"
        description="That page doesn't exist. Browse the portfolio or book a free consultation with Ananda Paudel."
        path="/404"
        noindex
      />
      <div className="min-h-screen bg-cream-50 pt-20 sm:pt-24 flex items-center justify-center">
        <div className="text-center max-w-md px-6 py-20">
          <p className="font-serif text-7xl text-matte-300 mb-3">404</p>
          <h1 className="font-serif text-3xl text-matte-900 font-light mb-4">
            That page doesn't exist
          </h1>
          <p className="font-sans text-sm text-matte-500 leading-relaxed mb-8">
            It may have moved when we restructured the site around our
            Consulting → Design → Build process. Try one of these instead.
          </p>
          <div className="flex flex-col gap-3">
            <Link
              to="/portfolio"
              className="inline-flex items-center justify-center gap-2 bg-matte-900 text-cream-100 font-sans text-sm tracking-wider px-8 py-4 hover:bg-walnut-700 transition-colors"
            >
              Browse the Portfolio <ArrowRight size={14} />
            </Link>
            <Link
              to="/book"
              className="inline-flex items-center justify-center gap-2 border border-walnut-300 text-walnut-600 font-sans text-sm tracking-wider px-8 py-4 hover:bg-walnut-500 hover:text-white hover:border-walnut-500 transition-colors"
            >
              <Calendar size={14} />
              Book a Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
